import { render, staticRenderFns } from "./index.vue?vue&type=template&id=790cc16b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=790cc16b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790cc16b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('790cc16b')) {
      api.createRecord('790cc16b', component.options)
    } else {
      api.reload('790cc16b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=790cc16b&scoped=true", function () {
      api.rerender('790cc16b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fd/setup/cate/index.vue"
export default component.exports